import { render, staticRenderFns } from "./edit_disk.vue?vue&type=template&id=6571c046&scoped=true&"
import script from "./edit_disk.vue?vue&type=script&lang=js&"
export * from "./edit_disk.vue?vue&type=script&lang=js&"
import style0 from "./edit_disk.vue?vue&type=style&index=0&id=6571c046&lang=scss&scoped=true&"
import style1 from "./edit_disk.vue?vue&type=style&index=1&id=6571c046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6571c046",
  null
  
)

export default component.exports